import { Component, OnDestroy, OnInit } from "@angular/core";
import { ColDef, ColGroupDef, GridApi, GridOptions } from "ag-grid-community";
import {
  RecordingJob,
  RecordingJobStatus,
} from "app/js/src/domain/recording-job";
import moment from "moment";
import { RecordingService } from "app/js/src/services/recording/recording.service";
import { RecordingSource } from "app/js/src/domain/recording-source";
import { Recording, RecordingStatus } from "app/js/src/domain/recording";
import { RecordingJobSourcesComponent } from "../recording-scheduler/recording-job-sources/recording-job-sources.component";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "evrideo-recording-history",
  templateUrl: "./recording-history.component.html",
  styleUrls: ["./recording-history.component.scss"],
})
export class RecordingHistoryComponent implements OnInit, OnDestroy {
  //@Input() jobs: RecordingJob[] = [];
  hidePagination = false;
  //scheduledHistoricalJobCacheUpdated: Subscription;
  gridOptions: GridOptions;
  inEditModeNode: any;
  inEditModeData: any;
  gridApi: GridApi;
  gridColumnApi: unknown;
  columnDefs: (ColDef | ColGroupDef)[] = [
    {
      headerName: "Name",
      field: "name",
      suppressSizeToFit: true,
    },
    {
      headerName: "Record Resources",
      cellRenderer: RecordingJobSourcesComponent,
      sortable: false,
    },
    {
      headerName: "Start Time",
      field: "startTime",
      sort: "desc",
      cellRenderer: this.formatDateTime.bind(this),
    },
    {
      headerName: "End Time",
      field: "endTime",
      cellRenderer: this.formatDateTime.bind(this),
    },
    {
      headerName: "Duration",
      cellRenderer: this.formatDuration,
    },
    {
      headerName: "Status",
      field: "recordings",
      cellRenderer: this.formatJobStatus,
      cellClass: () => "recording-status",
    },
  ];
  showManageJobOverlay = false;
  recordingJobToManage: any;
  localTimezone: string;
  constructor(
    private recordingService: RecordingService,
    private _route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.localTimezone = moment.tz.guess();
    this.gridOptions = <GridOptions>{
      context: { componentParent: this },
      defaultColDef: {
        resizable: false,
        lockPosition: true,
        sortable: true,
        cellStyle: { "line-height": "44px" },
      } as ColDef,
      rowHeight: 44,
      animateRows: true,
      paginationAutoPageSize: false,
      paginationPageSize: 15,
      paginationPageSizeSelector: false,
      pagination: true,
      getRowHeight: (e) => {
        let height = 44;
        if (e.data) {
          const sourcesCount = (e.data as RecordingJob).recordingSources.length;
          if (sourcesCount > 1) {
            height += (sourcesCount - 1) * 14;
          }
        }
        return height;
      },
      components: {
        recordingJobSourcesComponent: RecordingJobSourcesComponent,
      },
    };
    this.recordingService
      .get(
        this.recordingService.showLastCountSelectedValue,
        this.recordingService.startDateFrom,
        this.recordingService.startDateTo,
        null,
        null,
        [RecordingJobStatus.Finished, RecordingJobStatus.Stopped],
        true,
      )
      .then((jobs) => {
        this.updateJobsInGrid(jobs);
      });
  }
  ngOnDestroy(): void {
    /*if (this.scheduledHistoricalJobCacheUpdated) {
      this.scheduledHistoricalJobCacheUpdated.unsubscribe();
    }*/
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    //this.scheduledHistoricalJobCacheUpdated =      this.recordingService.getRecordingHistoricalJobCacheUpdateObserver().subscribe(this.updateJobsInGrid.bind(this));
    this.afterGridUpdateTrigger();
  }
  afterGridUpdateTrigger() {
    if (!this.gridApi) {
      return;
    }
    this.validatePagination();
  }

  validatePagination() {
    const pages = this.gridApi.paginationGetTotalPages();
    if (pages && pages > 1) {
      this.hidePagination = false;
    } else {
      this.hidePagination = true;
    }
  }
  updateJobsInGrid(rowData: any) {
    this.gridApi.setGridOption("rowData", rowData);
    this.afterGridUpdateTrigger();
  }

  formatDateTime(param: any) {
    return (param.value as moment.Moment)
      .tz(this.localTimezone)
      .format("Y/MM/DD HH:mm");
  }
  formatDuration(param: any) {
    const recordingJob = param.data as RecordingJob;
    const diff = recordingJob.endTime.diff(recordingJob.startTime);
    const hours = Math.floor(moment.duration(diff).asHours());
    return moment(diff).format(`[${hours}h]mm[m]ss[s]`);
  }
  streamingSourceNames(param: any) {
    const names = [];
    (param.value as RecordingSource[]).forEach((source) => {
      names.push(source.name);
    });
    return names.join(", ");
  }
  formatJobStatus(param: any) {
    let recordFailureCounter = 0;
    const recordings = param.value as Array<Recording>;
    recordings.forEach((record) => {
      if (record.status === RecordingStatus.Error) {
        recordFailureCounter++;
      }
    });
    let statusText;
    let statusIcon;
    if (recordFailureCounter === 0) {
      statusText = "Successfully Recorded";
      statusIcon = "success.svg";
    } else {
      if (recordFailureCounter === recordings.length) {
        statusText = "Failed";
        statusIcon = "failed.svg";
      } else {
        statusText = "Partialy failed";
        statusIcon = "low-quality.svg";
      }
    }
    return `<span>${statusText}</span> <img src="/assets/icons/${statusIcon}">`;
  }
}
